import { render, staticRenderFns } from "./PageLoaderComponent.vue?vue&type=template&id=f2ffe7c8"
import script from "./PageLoaderComponent.vue?vue&type=script&lang=js"
export * from "./PageLoaderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports